import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import http from "../services/http-common";
import { sortBy } from "lodash";

const useGetSeasonList = () => {
  let { seasonList } = useSelector((state) => ({ ...state.seasonList }));
  const [SeasonList, setSeasonList] = useState([]);
  const [error, setError] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true; // Variable pour vérifier si le composant est monté

    const fetchData = async () => {
      try {
        if (!seasonList || !seasonList?.data) {
          setLoaded(false);
          const response = await http.get(`/season/list`);

          if (isMounted) {
            let list = [];
            if (response && response.data) {
              response.data.map((season) => {
                list.push({ seasonId: season.seasonId, seasonType: season.seasonType, title: season.title, seasonNumber: season.seasonNumber });
              });
            }
            setSeasonList(sortBy(list, "seasonNumber")?.reverse());
            setError(null);
          }
        } else {
          let list = [];
          seasonList?.data.map((season) => {
            list.push({ seasonId: season.seasonId, seasonType: season.seasonType, title: season.title, seasonNumber: season.seasonNumber });
          });
          setSeasonList(sortBy(list, "seasonNumber")?.reverse());
          setError(null);
        }
      } catch (error) {
        if (isMounted) {
          setError(error.message);
          setSeasonList([]);
        }
      } finally {
        if (isMounted) {
          setLoaded(true);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  return { SeasonList, error, loaded };
};

export default useGetSeasonList;
